<div class="wrap">

    <h3>{{this.data.camera.name}}</h3>
    <p>Info:</p>

    <ul>
        <li>Serial: <strong>74081989-8ee1-46dc-24db-08d960847344</strong></li>
        <li>Ip: <strong>https://pz1.phoenix-ai.com</strong></li>
        <li>Port: <strong>443</strong></li>
        <ng-container *ngIf="data.camera.application.ApplicationName === 'SmartParking'">
            <li>Délai de dépassement: <strong>1h30</strong> </li>
        </ng-container>

    </ul>
    <!-- <div *ngIf="data.camera.application.ApplicationName === 'SmartWaste'">
        <agm-map [zoom]="zoom" [latitude]="lat" [longitude]="lng">
            <agm-marker [latitude]="data.camera.location.lat" [longitude]="data.camera.location.lng"></agm-marker>
        </agm-map>
    </div> -->
    <button type="button" (click)="dialogRef.close()">Fermer</button>

</div>